export default __webpack_public_path__ + "static/med-belinda-coker-284a938af30136cd426f9fdd979eacb4.png";